// src/mocks/handlers.ts
import { graphql, HttpResponse } from "msw";
import { YearlyOrderMetrics, YearlyPaymentMetrics } from "./graphql";

const DEFAULT_MONTH_DATA = {
  shipped: 0,
  inProgress: 0,
  printing: 0,
  failed: 0,
};

/**
 * @featureFlag useMocks
 * @description when active, use any existing mock service worker handlers instead of real calls
 */
// Set Feature Flag if this is a Vercel preview and it hasn't been set
if (window.location.hostname.includes("vercel.app") && localStorage.getItem("useMocks") === null) {
  localStorage.setItem("useMocks", "true");
}
export const useMocks = localStorage.getItem("useMocks") === "true";

export const handlers = [
  graphql.query("YearlyOrderMetrics", () => {
    return HttpResponse.json<{ data: YearlyOrderMetrics }>({
      data: {
        yearlyOrderMetrics: {
          customerPublicId: "mock-customer-id",
          yearsAvailable: [2024, 2025, 2026],
          years: {
            2024: {
              year: 2024,
              months: [
                { month: "Jan", ...DEFAULT_MONTH_DATA, shipped: 140 },
                { month: "Feb", ...DEFAULT_MONTH_DATA, shipped: 165, failed: 10 },
                { month: "Mar", ...DEFAULT_MONTH_DATA, shipped: 175 },
                { month: "Apr", ...DEFAULT_MONTH_DATA, shipped: 80, failed: 5 },
                { month: "May", ...DEFAULT_MONTH_DATA, shipped: 75 },
                { month: "Jun", ...DEFAULT_MONTH_DATA, shipped: 80, failed: 5 },
                { month: "Jul", ...DEFAULT_MONTH_DATA, shipped: 60 },
                { month: "Aug", ...DEFAULT_MONTH_DATA, shipped: 175 },
                { month: "Sep", ...DEFAULT_MONTH_DATA, shipped: 175 },
                { month: "Oct", ...DEFAULT_MONTH_DATA, shipped: 175 },
                { month: "Nov", ...DEFAULT_MONTH_DATA, shipped: 175 },
                { month: "Dec", ...DEFAULT_MONTH_DATA, shipped: 300 },
              ],
            },
            2025: {
              year: 2025,
              months: [
                { month: "Jan", ...DEFAULT_MONTH_DATA, shipped: 150 },
                { month: "Feb", ...DEFAULT_MONTH_DATA, shipped: 180, failed: 8 },
                { month: "Mar", ...DEFAULT_MONTH_DATA, shipped: 190 },
                { month: "Apr", ...DEFAULT_MONTH_DATA, shipped: 95, failed: 3 },
                { month: "May", ...DEFAULT_MONTH_DATA, shipped: 85 },
                { month: "Jun", ...DEFAULT_MONTH_DATA, shipped: 90, failed: 4 },
                { month: "Jul", ...DEFAULT_MONTH_DATA, shipped: 70, failed: 5, inProgress: 50, printing: 110 },
                { month: "Aug", ...DEFAULT_MONTH_DATA, shipped: 175 },
                { month: "Sep", ...DEFAULT_MONTH_DATA, shipped: 175 },
                { month: "Oct", ...DEFAULT_MONTH_DATA, shipped: 175 },
                { month: "Nov", ...DEFAULT_MONTH_DATA, shipped: 175 },
                { month: "Dec", ...DEFAULT_MONTH_DATA, shipped: 300 },
              ],
            },
            2026: {
              year: 2026,
              months: [
                { month: "Jan", ...DEFAULT_MONTH_DATA, shipped: 170 },
                { month: "Feb", ...DEFAULT_MONTH_DATA },
                { month: "Mar", ...DEFAULT_MONTH_DATA },
                { month: "Apr", ...DEFAULT_MONTH_DATA },
                { month: "May", ...DEFAULT_MONTH_DATA },
                { month: "Jun", ...DEFAULT_MONTH_DATA },
                { month: "Jul", ...DEFAULT_MONTH_DATA },
                { month: "Aug", ...DEFAULT_MONTH_DATA },
                { month: "Sep", ...DEFAULT_MONTH_DATA },
                { month: "Oct", ...DEFAULT_MONTH_DATA },
                { month: "Nov", ...DEFAULT_MONTH_DATA },
                { month: "Dec", ...DEFAULT_MONTH_DATA },
              ],
            },
          },
        },
      },
    });
  }),
  graphql.query("YearlyPaymentMetrics", () => {
    return HttpResponse.json<{ data: YearlyPaymentMetrics }>({
      data: {
        yearlyPaymentMetrics: {
          customerPublicId: "mock-customer-id",
          nextChargeDate: "07/01/2026",
          yearsAvailable: [2024, 2025, 2026],
          years: {
            2024: {
              year: 2024,
              months: [
                { month: "Jan", totalPaymentAmount: 1400 },
                { month: "Feb", totalPaymentAmount: 4650 },
                { month: "Mar", totalPaymentAmount: 10000 },
                { month: "Apr", totalPaymentAmount: 8000 },
                { month: "May", totalPaymentAmount: 7500 },
                { month: "Jun", totalPaymentAmount: 8000 },
                { month: "Jul", totalPaymentAmount: 6000 },
                { month: "Aug", totalPaymentAmount: 1750 },
                { month: "Sep", totalPaymentAmount: 17500 },
                { month: "Oct", totalPaymentAmount: 1750 },
                { month: "Nov", totalPaymentAmount: 17500 },
                { month: "Dec", totalPaymentAmount: 3000 },
              ],
            },
            2025: {
              year: 2025,
              months: [
                { month: "Jan", totalPaymentAmount: 1500 },
                { month: "Feb", totalPaymentAmount: 1800 },
                { month: "Mar", totalPaymentAmount: 19000 },
                { month: "Apr", totalPaymentAmount: 950 },
                { month: "May", totalPaymentAmount: 8500 },
                { month: "Jun", totalPaymentAmount: 9000 },
                { month: "Jul", totalPaymentAmount: 7000 },
                { month: "Aug", totalPaymentAmount: 1750 },
                { month: "Sep", totalPaymentAmount: 17500 },
                { month: "Oct", totalPaymentAmount: 1750 },
                { month: "Nov", totalPaymentAmount: 17500 },
                { month: "Dec", totalPaymentAmount: 3000 },
              ],
            },
            2026: {
              year: 2026,
              months: [
                { month: "Jan", totalPaymentAmount: 7000 },
                { month: "Feb", totalPaymentAmount: 0 },
                { month: "Mar", totalPaymentAmount: 0 },
                { month: "Apr", totalPaymentAmount: 0 },
                { month: "May", totalPaymentAmount: 0 },
                { month: "Jun", totalPaymentAmount: 0 },
                { month: "Jul", totalPaymentAmount: 0 },
                { month: "Aug", totalPaymentAmount: 0 },
                { month: "Sep", totalPaymentAmount: 0 },
                { month: "Oct", totalPaymentAmount: 0 },
                { month: "Nov", totalPaymentAmount: 0 },
                { month: "Dec", totalPaymentAmount: 0 },
              ],
            },
          },
        },
      },
    });
  }),
];
